import ReactECharts from "echarts-for-react";
import { useState, useEffect } from "react";
import { RefreshCcw } from "react-feather";
import { getMonthlyJobTrend } from "../../api/transporterDashboardApi";
import LoadingSpinner from "../../components/LoadingSpinner";

const MonthlyJobTrend = ({ userId, transporter, refreshTrigger }) => {
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [localRefresh, setLocalRefresh] = useState(0);

  useEffect(() => {
    const fetch = async () => {
      setLoading(true);
      setError(null);
      try {
        const ids = transporter && transporter.length > 0 ? transporter : null;
        const result = await getMonthlyJobTrend(userId, ids);
        setData(result ?? []);
      } catch (err) {
        setError("Failed to load monthly trend.");
        console.error(err);
      } finally {
        setLoading(false);
      }
    };
    fetch();
  }, [userId, transporter, refreshTrigger, localRefresh]);

  const option = {
    tooltip: {
      trigger: "axis",
      formatter: (params) => {
        const p = params[0];
        return `${p.name}<br/><b>${p.value}</b> jobs`;
      },
    },
    grid: { left: "3%", right: "4%", bottom: "3%", containLabel: true },
    xAxis: {
      type: "category",
      boundaryGap: false,
      data: data.map((d) => d.month),
      axisLabel: { fontSize: 11 },
    },
    yAxis: { type: "value", axisLabel: { fontSize: 11 } },
    series: [
      {
        name: "Jobs",
        type: "line",
        smooth: true,
        data: data.map((d) => d.count),
        symbol: "circle",
        symbolSize: 6,
        lineStyle: { width: 2.5, color: "#185FA5" },
        itemStyle: { color: "#185FA5" },
        areaStyle: {
          color: {
            type: "linear",
            x: 0, y: 0, x2: 0, y2: 1,
            colorStops: [
              { offset: 0, color: "rgba(24,95,165,0.25)" },
              { offset: 1, color: "rgba(24,95,165,0.02)" },
            ],
          },
        },
        label: { show: true, position: "top", fontSize: 11, color: "#555" },
      },
    ],
  };

  return (
    <div
      className="ui segment"
      style={{ boxShadow: "rgba(149,157,165,0.2) 0px 8px 24px", margin: "8px 0" }}
    >
      <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
        <h3>Monthly Job Trend</h3>
        <RefreshCcw size={16} style={{ cursor: "pointer" }} onClick={() => setLocalRefresh((k) => k + 1)} />
      </div>
      {loading ? (
        <div style={{ height: "320px", display: "flex", alignItems: "center", justifyContent: "center" }}>
          <LoadingSpinner />
        </div>
      ) : error ? (
        <div style={{ height: "320px", display: "flex", alignItems: "center", justifyContent: "center", color: "#dc2626", fontSize: "13px" }}>
          {error}
        </div>
      ) : data.length === 0 ? (
        <div style={{ height: "320px", display: "flex", alignItems: "center", justifyContent: "center", color: "#aaa", fontSize: "14px" }}>
          No data available
        </div>
      ) : (
        <ReactECharts option={option} style={{ width: "100%", height: "320px" }} />
      )}
    </div>
  );
};

export default MonthlyJobTrend;